import * as React from "react";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useHistory } from "react-router";
import { MyContext } from "./MainMenu";
import type { DrawerContextValue, MainMenuToolbarProps } from "../types/ui";

export const MainMenuToolbar = ({
  backLink,
  title
}: MainMenuToolbarProps) => {
  const myContext = React.useContext(MyContext) as DrawerContextValue;

  const history = useHistory();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          {backLink && (
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={() => {
                if (history.length > 1) {
                  history.goBack();
                } else {
                  history.replace(backLink);
                }
              }}
            >
              <ArrowBackIcon fontSize="small" />
            </IconButton>
          )}

          <Typography variant="h6" component="div" noWrap sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={myContext.handleDrawerToggle}
            sx={{ display: { sm: "none" } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default MainMenuToolbar;
